// JS-детект «мобильности» должен совпадать с Tailwind `md:` (min-width: 768px).
// Поэтому мобилкой считаем < 768px, иначе на ровно 768px inline-высота из JS
// будет сражаться с `md:h-auto`.
export const MOBILE_QUERY = "(max-width: 767px)";